import { CategoryDetail } from '~/api/categories/_types';

export const useCategoryDetailStore = defineStore('category', () => {
    const activeCategory = ref<CategoryDetail | null>(null);

    const reset = () => {
        activeCategory.value = null;
    };

    return {
        activeCategory,
        reset,
    };
});
